<template>
  <AuthorPrmTooltip
    :author-id="person._id"
    :prm-level="person.prm_status"
    :is-stakeholder="person.has_social_media"
    :title="person.name"
    :group="person.group"
    is-top
  >
    <img
      class="img-bubble"
      :src="
        !person.photo || imgUndefined ? defaultProfilePicture : person.photo
      "
      :style="{ borderColor: person.group?.color }"
      alt="Photo de profil"
      @error="imgUndefined = true"
    />
  </AuthorPrmTooltip>
</template>

<script setup>
import { ref } from "vue";
import AuthorPrmTooltip from "@follaw-fr/components/reusable/atoms/AuthorPrmTooltip.vue";
import defaultProfilePicture from "@/assets/img/user.jpeg";

defineProps({
  person: {
    type: Object,
    required: true,
  },
});

// Set a default picture when the picture url fails to load
const imgUndefined = ref(false);
</script>

<style scoped lang="scss">
@import "@/assets/sass/helpers/variables";

.img-bubble {
  object-fit: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 3px solid transparent; // color is overriden by component when there is a group color
  box-shadow: 0px 3px 10px 0px #00000014;
}
</style>
